export default "__VITE_ASSET__61c4f3f7__"